export default __webpack_public_path__ + "static/media/large.8817f9d5.jpg";